<template>
    <div id="repairRecords" class="business-content-main">
        <div class="bread-nav">
            <div>您当前位置：</div>
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item>客服</el-breadcrumb-item>
                <el-breadcrumb-item>检修管理</el-breadcrumb-item>
                <el-breadcrumb-item>检修订单售后</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="search-ctn">
            <div class="search-name">检修单号:</div>
            <el-input
                    style="width: 180px"
                    class="search-item"
                    size="small"
                    v-model="searchData.OrderCode"
                    placeholder="请输入检修单号"
            ></el-input>
            <div class="search-name">汽修厂:</div>
            <el-input
                    style="width: 180px"
                    class="search-item"
                    size="small"
                    v-model="searchData.EntpName"
                    placeholder="请输入汽修厂名称"
            ></el-input>
            <div class="search-name">车主:</div>
            <el-input
                    style="width: 180px"
                    class="search-item"
                    size="small"
                    v-model="searchData.UName"
                    placeholder="请输入车主名称"
            ></el-input>
            <div class="search-name">时间:</div>
            <el-date-picker
                    :picker-options="startDateOps"
                    class="search-item"
                    v-model="searchData.StartDate"
                    format="yyyy-MM-dd"
                    value-format="yyyy-MM-dd"
                    type="date"
                    size="small"
                    placeholder="选择日期"
            ></el-date-picker>
            <span class="search-name">至</span>
            <el-date-picker
                    :picker-options="endDateOps"
                    class="search-item"
                    v-model="searchData.EndDate"
                    format="yyyy-MM-dd"
                    value-format="yyyy-MM-dd"
                    type="date"
                    size="small"
                    placeholder="选择日期"
            ></el-date-picker>
            <div class="search-name">状态:</div>
            <el-select
                    size="small"
                    class="search-item"
                    v-model="searchData.State"
                    placeholder="请选择"
            >
                <el-option
                        v-for="item in orderState"
                        :key="item.Tkey"
                        :label="item.Text"
                        :value="item.Value"
                ></el-option>
            </el-select>
            <div>
                <el-button
                        type="primary"
                        size="small"
                        icon="el-icon-search"
                        class="search-btn"
                        @click="handleSearch"
                >查询</el-button>
                <el-button
                        type="primary"
                        size="small"
                        icon="el-icon-refresh"
                        class="search-btn"
                        @click="resetSearch"
                >重置</el-button>
            </div>
        </div>
        <div class="table-ctn">
            <el-table
                    :header-cell-style="{background:'#F2F6FC'}"
                    :data="recordsList"
                    border=""
                    style="width: 100%"
            >
                <el-table-column
                        width="190px"
                        show-overflow-tooltip
                        prop="OrderCode"
                        label="单号">
                </el-table-column>
                <el-table-column
                        show-overflow-tooltip
                        prop="EntpName"
                        label="汽修厂">
                </el-table-column>
                <el-table-column
                        show-overflow-tooltip
                        prop="UName"
                        label="车主">
                </el-table-column>
                <el-table-column
                        show-overflow-tooltip
                        prop="PhoneNum"
                        label="车主电话">
                </el-table-column>
                <el-table-column
                        show-overflow-tooltip
                        prop="HappenTime"
                        label="问题发生时间">
                </el-table-column>
                <el-table-column
                        show-overflow-tooltip
                        prop="SceneDesc"
                        label="问题发生场景">
                </el-table-column>
                <el-table-column
                        show-overflow-tooltip
                        prop="Reason"
                        label="申请原因补充">
                </el-table-column>
                <el-table-column
                        show-overflow-tooltip
                        prop="StateName"
                        label="状态">
                </el-table-column>
                <el-table-column label="操作">
                    <template slot-scope="scope">
                        <el-button
                                v-if="scope.row.State == 0"
                                type="text"
                                size="small"
                                @click="handleResult(scope.row)"
                        >处理</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div class="pagination-ctn">
            <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="searchData.page"
                    :page-sizes="[10, 20, 30, 40, 50]"
                    :page-size="searchData.limit"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="searchData.totalCount"
            ></el-pagination>
        </div>
        <el-dialog
                title="处理"
                :visible.sync="dialogVisible"
                width="800px"
        >   <div class="dialog-content">
            <div class="dialog-content-main">
                <span>处理描述结果:</span>
                <textarea v-model="resultDir"></textarea>
            </div>
            <div class="btn-ctn">
                <el-button size="small" type="primary" class="btn-primary" @click="submitResult">提交</el-button>
            </div>
        </div>
        </el-dialog>
    </div>
</template>

<script>
    export default {
        name: "repairRecords",
        data() {
            return {
                startDateOps: {
                    disabledDate: time => {
                        if (this.searchData.EndDate != "") {
                            return time.getTime() > new Date(this.searchData.EndDate);
                        }
                    }
                },
                endDateOps: {
                    disabledDate: time => {
                        if (this.searchData.StartDate != "") {
                            return time.getTime() < new Date(this.searchData.StartDate);
                        }
                    }
                },
                orderState: [
                    { Tkey: 3, TValue: "待审核" },
                    { Tkey: 0, TValue: "已审核" }
                ],
                searchData: {
                    OrderCode: "",
                    EntpName: "",
                    UName: "",
                    CarNum: "",
                    State: "",
                    StartDate: "",
                    EndDate: "",
                    page: 1, // 当前页数
                    limit: 10, // 每页限制条数
                    totalCount: 0
                },
                recordsList: [],
                permission:{},
                dialogVisible:false,
                handleId:'',
                resultDir:'',
            };
        },
        mounted() {
            this.getRecordsList();
            this.getState()
            this.$util.getPermission('订单售后').then((res)=>{
                this.permission = res
            })
        },
        methods: {
            submitResult (){
                this.axios
                    .post("/RepairManagement/ProcessRepairOrderAfterSale", {
                        afterSaleId:this.handleId,
                        processResult:this.resultDir
                    })
                    .then(result => {
                        this.$util.successMsg('提交成功')
                        this.dialogVisible = false
                        this.handleId = ''
                        this.resultDir = ''
                        this.getRecordsList()
                    });
            },
            handleSearch() {
                this.searchData.page = 1;
                this.getRecordsList();
            },
            getRecordsList() {
                this.axios
                    .get("/RepairManagement/GetRepairOrderAfterSaleList", {
                        params: this.searchData
                    })
                    .then(result => {
                        this.recordsList = result.data.data;
                        this.searchData.totalCount = result.data.count;
                    });
            },
            // 获取状态
            getState() {
                this.axios
                    .get("/RepairManagement/GetRepairOrderAfterSaleStateList", {
                        params: this.searchData
                    })
                    .then(result => {
                        this.orderState = result.data.data;
                    });
            },
            resetSearch() {
                this.searchData = {
                    OrderCode: "",
                    EntpName: "",
                    UName: "",
                    CarNum: "",
                    State: "",
                    StartDate: "",
                    EndDate: "",
                    page: 1, // 当前页数
                    limit: 10 // 每页限制条数
                };
            },
            handleSizeChange(val) {
                this.searchData.page = 1;
                this.searchData.limit = val;
                this.getRecordsList();
            },
            handleCurrentChange(val) {
                this.searchData.page = val;
                this.getRecordsList();
            },
            handleResult(val) {
                this.handleId = val.AfterSaleId
                this.dialogVisible = true
            }
        }
    };
</script>
<style lang="less" scoped>
    .btn-ctn {
        text-align: right;
        padding-right: 25px;
        padding-top: 20px ;
    }
    .dialog-content-main {
        display: flex;
        align-items: flex-start;
        justify-content: center;
        span {
            margin-right: 20px;
        }
        textarea {
            resize: none;
            width: 600px;
            height: 100px;
            border: 1px solid @border3Color;
            border-radius: 6px;
        }
    }
</style>
